import { IAppConfiguration } from './IAppConfiguration';
export default {
  logrocketKey: undefined,
  aptorApi: 'https://api.lagportalen.se',
  clientId: 'f8b57dc0-cd2f-4bca-b550-f34cc4218060',
  tenantName: 'aptoronline',
  tinyMCEApiKey: '1njdfilpf3cwf9ws8gnrvdcmzt6pufa2fd1bj3165lcs8spl',
  redirectUrl: 'https://lagportalen.se/',
  policyName: 'B2C_1A_signup_signin',
  inivtePolicy: 'B2C_1A_signup_invitation',
  forgotPasswordPolicy: 'B2C_1A_passwordreset',
  redirectLogoutUrl: 'https://lagportalen.se/',
  tenantId: '4cf894e2-2dde-41ca-865c-b4f8e0e4717a',
  enableImpersonation: true,
  knownAuthority: 'https://aptoronline.b2clogin.com',
   app_id: 'zl8jjjnt',
  scopes: ['https://aptoronline.onmicrosoft.com/bb5d7358-b61e-46c4-8333-ff25d0e904ba/user_impersonation'],
} as IAppConfiguration;